import React from 'react';
import { handleView } from '../handle_view';
import { ClearanceInfoLightBoxStore } from '../../_flux/stores/clearance_info_light_box_store';
import { LightBox } from '../../_flux/components/clearance_info_light_box/light_box';
import { hide } from '../../_flux/actions/clearance_info_light_box_actions';
import { addProductToCart } from '../sidebar/pdp';
import FinderStation from '../../_flux/components/fitting_station_finder/finder/finder_station';

const stores = {
  lightBox: ClearanceInfoLightBoxStore,
};

const render = ({ lightBox }) => (
  <LightBox
    visible={lightBox.visible}
    isAddToCart={lightBox.isAddToCart || lightBox.isFittingStation}
    onClose={hide}
    addProductToCart={() => window.addToCartDeferred.resolve()}
  />
);

export const init = (container, options) => handleView(stores, render, options, container);
